import { render, staticRenderFns } from "./security-group-rule-list.vue?vue&type=template&id=6ef5e361&scoped=true&"
import script from "./security-group-rule-list.vue?vue&type=script&lang=js&"
export * from "./security-group-rule-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5e361",
  null
  
)

export default component.exports